<template>
  <b-container class="pt-2 pb-2 border-info border">
    <b-row>
      <b-col><h5>Attachments</h5></b-col>
    </b-row>
    <div data-test-path="market-supplier-documents">
      <b-row v-for="attachmentInfo in attachments" :key="attachmentInfo.fileId">
        <b-button variant="link" @click="downloadAttachment(attachmentInfo)"
                  :data-test-path="attachmentInfo.__label.substring(0,10)">
          {{ attachmentInfo.__label }}
        </b-button>
      </b-row>
    </div>

  </b-container>
</template>

<script>
import MixinFormComponentConfig from "@/server/com/silkplm/engine/forms/schema/definition/MixinFormComponentConfig";
import WCLProduct from "@/server/com/silkplm/model/plm/WCLProduct";
import BrandingProduct from "@/server/com/silkplm/model/plm/BrandingProduct";

export default {
  name: "DocumentsList",
  created() {
  },

  async mounted() {
    this.parentForm.onLoaded(async () => {
      /**
       * @type {WCLProduct}
       */
      let instance = this.parentForm.originalSource;
      await this.refreshInstance(instance);
    });
  },

  methods: {
    setEditorMode(val) {
    },

    setReadOnly(readOnly) {
      this.readOnly = this.mixinConfig.readOnly || readOnly
    },

    async downloadAttachment(attachment) {
      window.location.href = attachment.downloadUrl;
    },

    async refreshInstance(instance) {
      this.attachments = instance.attachments;
      if (this.attachments) {
        for (let attachment of this.attachments) {
          attachment.__label = attachment.data.name;
        }
      }
    },
  },

  data: function () {
    return {
      /**
       * @type{LabelInfo[]}
       */
      permission: true,
      readOnly: true,
      attachments: null,
    }
  },

  props: {
    mixinConfig: {type: MixinFormComponentConfig},

    /** @type{FormsListContext|*}*/
    context: {default: null},

    /** @type{string|*} EDIT or NEW*/
    mode: {default: null},
    editorMode: {default: false},

    /** @type{FormModel|*}*/
    parentForm: {default: null},

    /** @type{FormModel|*}*/
    masterFormModel: {default: null},
  }
}
</script>